var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.orb ? _c('div', {
    staticClass: "pa-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Orb')
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "float-right px-4"
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.orbicon.format(_vm.id) + '.png',
      "target": "_blank"
    }
  }, [_c('v-avatar', {
    key: "masterorb-icon-".concat(_vm.id),
    attrs: {
      "size": _vm.$size(64)
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.orbicon.format(_vm.id) + '.jpg'
    }
  })], 1)], 1)]), _c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.orb.m_Name))]), _vm.orb.m_TitleType != -1 && _vm.$i18n.locale != 'ja' ? _c('p', {
    staticClass: "px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$name(_vm.$store.state.$db.TitleList[_vm.orb.m_TitleType].m_DisplayName)) + " — " + _vm._s(_vm.$t('Master Orb')))]) : _vm._e(), _vm.orb.m_Class != -1 && _vm.$i18n.locale != 'ja' ? _c('p', {
    staticClass: "px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t("Classes.".concat(_vm.orb.m_Class))) + " — " + _vm._s(_vm.$t('Master Orb')))]) : _vm._e(), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale == 'ja',
      expression: "$i18n.locale=='ja'"
    }],
    attrs: {
      "target": "_blank",
      "href": _vm.$const.wikiwiki._.format('きらら装備')
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s('きらら装備') + " - " + _vm._s(_vm.$t('Wikiwiki.Title')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1), _c('v-divider'), _c('Ad', {
    key: "master-orb-".concat(_vm.id)
  }), _c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Master Skills')))]), _vm._l(_vm.orb.m_SkillIDs, function (id) {
    return _c('Skill', {
      key: "masterorb-skill-".concat(id),
      attrs: {
        "id": id,
        "owner": "MST",
        "max": "1"
      }
    });
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }